import { useQuery, UseQueryOptions } from 'react-query';

import client from 'client';

type PhotoSet = {
    small: string;
    medium: string;
    large: string;
};

export type User = {
    company: string;
    country: string;
    emails: string[];
    firstName: string;
    groupId: number;
    id: number;
    industry: string;
    lastName: string;
    photoSet: PhotoSet;
    photoUrl: string;
    primaryEmail: string;
    primaryEmailValid: boolean;
    status: string;
    title: string;
    anonymous: boolean;
    moderatorName?: string;
    admin: boolean;
};

const fetchUserProfile = async () => {
    const response = await client().get<User>('/api/v2/userProfile');
    return response.data;
};

const useUserProfile = (options?: UseQueryOptions<User>) => {
    return useQuery<User, Error>(['user'], () => fetchUserProfile(), options);
};

export default useUserProfile;
